import { getCookieValue } from './verification.js'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

export const deleteArticles = () => {
  let location = ''

  if (sessionStorage.getItem('location')) {
    location = sessionStorage.getItem('location')
  } else if (getCookieValue('thlocation')) {
    location = getCookieValue('thlocation')
  }

  let articles = document.querySelectorAll('article, [data-banner-buttons], .downloads .button, .preview, .past-editions__entries')

  if (location && articles) {
    // console.log(location)

    articles.forEach((article) => {
      if (!article.classList.contains(location)) {
        article.remove()
      }
    })

    ScrollSmoother.refresh()
  }
}

export default () => {}
